exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-container{margin-top:10px}.boardbar-label{margin-right:10px;font-weight:600}.location-filter{display:inline-block;width:350px;padding-bottom:0}.pin{margin-top:calc(50vh - 200px)}.pin .pin-entry input{min-width:100%;text-align:center}.pin button{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27f312ec","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pages/View.vue
// module id = 645
// module chunks = 0